import { Accordion } from '../../../../../components/general/accordion';
import SpaIcon from '@mui/icons-material/Spa';
import { Grid } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { PqrInitialCausalityProps } from './props';
import { usePqrInitialCausality } from './hook';

export const PqrDataInitialCausality = ({
    initialCausality,
}: PqrInitialCausalityProps) => {
    const { formik } = usePqrInitialCausality(initialCausality);

    return (
        <Accordion
            title="CAUSALIDAD INICIAL"
            icon={<SpaIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={false}
            mt={0}
        >
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            >
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Producto"
                        name="product"
                        size="small"
                        value={formik.values.product}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Motivo"
                        name="motive"
                        size="small"
                        value={formik.values.motive}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Submotivo 1"
                        name="submotive1"
                        size="small"
                        value={formik.values.submotive1}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Submotivo 2"
                        name="submotive2"
                        size="small"
                        value={formik.values.submotive2}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Submotivo 3"
                        name="submotive3"
                        size="small"
                        value={formik.values.submotive3}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Submotivo 4"
                        name="submotive4"
                        size="small"
                        value={formik.values.submotive4}
                    />
                </Grid>
            </Grid>
        </Accordion>
    );
};
